import { render, staticRenderFns } from "./FichaClinicaCheckbox.vue?vue&type=template&id=c6c98a1e&scoped=true&"
import script from "./FichaClinicaCheckbox.vue?vue&type=script&lang=js&"
export * from "./FichaClinicaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FichaClinicaCheckbox.vue?vue&type=style&index=0&id=c6c98a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c98a1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VTextField})
